import { Grid, Typography } from "@mui/material";
import { memo } from "react";

import { products } from "../utils/index.js";
import CycloptCard from "../components/CycloptCard.js";

const HomeUnauthenticated = () => (
	<Grid container direction="column" alignItems="flex-start" justifyContent="center">
		<Typography fontSize={26} fontWeight="bold">{"All Products"}</Typography>
		<Grid width="100%" container spacing={5} sx={{ padding: "15px 0px"}}>
			{products.map((product) => (
				<CycloptCard key={product.id} isBought={false} product={product} />
			))}
		</Grid>
	</Grid>
);

export default memo(HomeUnauthenticated);
